<template>
  <div>
    <p class="mb-3">What is the charge on the molecule with the Lewis structure shown below?</p>

    <p class="mb-1 pl-8">
      <img :src="$publicAsset('/img/assignments/CN2_LS.png')" width="120px" />
    </p>

    <v-form @submit.prevent="submitResponse">
      <v-radio-group v-model="inputs.input1" :disabled="!allowEditing">
        <v-radio
          v-for="option in options"
          :key="option.value"
          class="d-inline-block"
          :value="option.value"
        >
          <template #label>
            <stemble-latex :content="option.text" />
          </template>
        </v-radio>
      </v-radio-group>
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex';

export default {
  name: 'Question330',
  components: {StembleLatex},
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      // Put a list of inputs or computed properties here to be sent for marking

      inputs: {
        input1: null,
      },
      options: [
        {text: '$+1$', value: '+1'},
        {text: '$0$', value: '0'},
        {text: '$-1$', value: '-1'},
        {text: '$-2$', value: '-2'},
        {text: '$-3$', value: '-3'},
      ],
    };
  },
};
</script>
